import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAppAccess } from '../context/AppAccessContext';
import AccessDeniedPage from '../pages/AccessDeniedPage';

interface AppRouteProps {
  appCode: string;
}

/** Gates a route subtree behind the Application entitlement/assignment check. */
const AppRoute: React.FC<AppRouteProps> = ({ appCode }) => {
  const { availableApps } = useAppAccess();
  return availableApps.includes(appCode) ? <Outlet /> : <AccessDeniedPage />;
};

export default AppRoute;
